module.exports = __webpack_public_path__ + "static/media/no-flag.594833e8.svg";